import { Enrollment, Field, FieldGeometry } from "@/types/field";
import { UseQueryResult } from "@tanstack/react-query";
import { createContext, Dispatch, SetStateAction } from "react";
import { CropCycleV2 } from "@/types/cropCycle";
import { Imagery, ImageryType } from "@/types/imagery";
import { Coordinates } from "../utils/map";
import { NaveWaterEstimate } from "@/types/water";
import { ManagementZones } from "@/types/managementZones";

type FieldDashboardContextType = {
    fieldId?: string;
    cropCycleQueryV2: UseQueryResult<CropCycleV2[], Error>;
    fieldImageryQuery: UseQueryResult<Imagery[], Error>;
    selectedCropCycle: CropCycleV2 | null;
    geometryQuery: UseQueryResult<FieldGeometry, Error>;
    fieldQuery: UseQueryResult<Field, Error>;
    setSelectedCropCycle: Dispatch<SetStateAction<CropCycleV2 | null>>;
    filteredImagery: Imagery[];
    selectedImage?: Imagery;
    setSelectedImage: Dispatch<SetStateAction<Imagery | undefined>>;
    imageryBbox?: Coordinates | undefined;
    fieldIsAdvanced: boolean;
    fieldIsStandard: boolean;
    fieldIsComplete: boolean;
    imageType: ImageryType;
    setImageType: Dispatch<SetStateAction<ImageryType>>;
    fieldBbox?: Coordinates | undefined;
    fieldEnrollmentQuery: UseQueryResult<Enrollment[], Error>;
    imageryOptions: { key: ImageryType; label: string }[];
    fieldHasIrrigation: boolean;
    fieldWaterQuery: UseQueryResult<NaveWaterEstimate[], Error>;
    selectedDate: string | undefined;
    setSelectedDate: Dispatch<SetStateAction<string | undefined>>;
    managementZonesQuery: UseQueryResult<ManagementZones[], Error>;
    imageryVisible: boolean;
    setImageryVisible: Dispatch<SetStateAction<boolean>>;
    fieldIsTrial: boolean;
    fieldIsMonitoring: boolean;
    fieldIsPreview: boolean;
};

const FieldDashboardContext = createContext<FieldDashboardContextType | null>(
    null,
);

export default FieldDashboardContext;
export type { FieldDashboardContextType };
